import { getFloatingNumber } from './getFloatingNumber';
import { getImageDimensions } from './getImageDimensions';

const MAX_SCALE = 1;
const MIN_SCALE = 0.2;

export const getUpdatedLogos = async (logos, widgetToken) => {
  const urlDimensionsMap = new Map();

  return await Promise.all(
    Object.values(logos).map(async (logo = {}) => {
      const logoData = logo.file?.data;
      const logoURL = logoData?.url;
      if ((logo.width && logo.height) || !logoURL) {
        return logo;
      }

      let width = logoData?.width;
      let height = logoData?.height;

      if (!width || !height) {
        const cachedResult = urlDimensionsMap.get(logoURL);
        if (cachedResult) {
          width = cachedResult.width;
          height = cachedResult.height;
        } else {
          const dimensions = await getImageDimensions(logoURL, widgetToken);
          urlDimensionsMap.set(logoURL, dimensions);
          width = dimensions.width;
          height = dimensions.height;
        }
      }

      const aspectRatio = Math.min(
        getFloatingNumber(height / width),
        MAX_SCALE
      );

      return {
        ...logo,
        aspectRatio: Math.max(aspectRatio, MIN_SCALE)
      };
    })
  );
};
